<template>
  <div class="iphone-series">
      <!-- 背景图容器 -->
      <div class="background-container" :style="backgroundStyle">
        <!-- 第一行文字 -->
        <div class="title-line"><span><img :src="'https://txxzdata.riverbaymart.com/images/hot-icon.png'" class="hotIcon"></span>{{ jinGangTuBg.title }}</div>
        <!-- 第二行文字 -->
        <div class="subtitle-line">{{ jinGangTuBg.subtitle }}</div>
		<!-- 商品卡片容器 -->
		<div class="goods-container">
		  <!-- 第一个商品卡片 -->
		  <div class="goods-card" v-for="(goods, index) in jinGangTuSH[0]" :key="goods.goods_id" @click="todetail(goods.goods_id)">
		    <img 
		            v-if="index < 3"
		            :src="`https://txxzdata.riverbaymart.com/images/hot-Grade${index + 1}.png`"
		            class="rank-icon"
		            :alt="`第${index + 1}名`"
		          />
			<img :src="goods.imgurl" :alt="goods.title" class="goods-image">
		    <div class="goods-info">
		      <div class="goods-title">{{ formatTitle(goods.title) }}</div>
			  <div class="goods-price">¥{{ goods.price }}/天</div>
		    </div>
		  </div>
		</div>
      </div>
    </div>
</template>

<script>
export default {
  name: "jinGangTu",
  props: {
    jinGangTuBg:Object,
	jinGangTuSH:Array
  },
  data() {
    return {
      isHot:true
    }
  },
 computed:{
   // this.getJinGangTu();
    backgroundStyle() {
         if (!this.jinGangTuBg.backgroundImg) {
           return {};
         }
         
         // 拼接完整的图片URL
         const bgUrl = this.jinGangTuBg.backgroundImg.startsWith('http') 
           ? this.jinGangTuBg.backgroundImg 
           : `https://img.riverbaymart.com/${this.jinGangTuBg.backgroundImg}`;
         
         return {
           backgroundImage: `url(${bgUrl})`,
           backgroundSize: 'cover',
           backgroundPosition: 'center',
           backgroundRepeat: 'no-repeat'
         };
       }
  },
  mounted() {
  },
  methods: {
	  todetail(id){
	  	// const { id, activity_id } = item;
	  	this.$router.push({ name: "goods", query: { goods_id: id } })
	  },
	  formatTitle(title) {
	        if (!title) return '';
	        return title.length > 10 ? title.substring(0, 11) + '...' : title;
	      }
  }
}
</script>
<style scoped>
.iphone-series {
  width: 100%;
  margin: 20px 0;
}

.background-container {
  position: relative;
  height: 100%;
  flex-direction: column;
  width: 95%;
  margin: 0 auto;
  border-radius: 7.8px;
  padding: 13.5px 10px 15px;
}

/* 第一行文字 */
.title-line {
  font-size: 16.64px;
  font-weight: 700;
  color: #333333;
}

.hotIcon{
	height: 18.2px;
	width: 15.08px;
	margin-right: 7.8px;
	vertical-align: center;
}

/* 第二行文字 */
.subtitle-line {
  font-size: 13px;
  line-height: 26px;
  color: #FF5F2D;
  margin-bottom: 5px;
}

/* 商品卡片容器 */
.goods-container {
  display: flex;
  justify-content: space-between;
  /* padding: 15px; */
  
  /* gap: 10px; */
}


.goods-card {
  border-radius: 8px;
  /* padding: 10px; */
  /* border: 1px solid red; */
  background: white;
  width: 31%;
}

.goods-image {
  width: 100%;
  padding: 7.5px 11.5px;
}

.goods-title {
  text-align: center;
  font-size: 13.52px;
  font-weight: 500;
  line-height: 15.6px;
  margin-bottom: 5.1px;
}

.goods-price {
  font-size: 13.52px;
  text-align: center;
  color: red;
  line-height: 20.8px;
  margin-bottom: 5px;
}


.rank-icon {
  position: absolute;
  width: 20px;
  height: 26.5px;
  z-index: 10;
  margin-left: 5px;
  margin-top: 5px;
}


</style>